import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { BackfillManualChannelSchema } from "./get-support-backfill-messages";

export const TriggerSupportV2BackfillResult = z.object({
  teamId: zExt.objectId(),
  success: z.boolean(),
  message: z.string(),
  workflowId: z.string().optional(),
  integrationId: z.string().optional(),
  channelIdentifier: z.string().optional(),
});
export type TriggerSupportV2BackfillResult = z.infer<
  typeof TriggerSupportV2BackfillResult
>;

/** 366 days: full calendar year, leap-year inclusive. */
export const MAX_BACKFILL_RANGE_DAYS = 366;

export const triggerSupportV2Backfill = unaryRpc({
  name: "triggerSupportV2Backfill" as const,
  input: z
    .object({
      teamId: zExt.objectId(),
      integrationId: z.string().min(1),
      channel: BackfillManualChannelSchema,
      startDate: z.date(),
      endDate: z.date(),
    })
    .refine(({ startDate, endDate }) => endDate > startDate, {
      message: "End date must be after start date.",
    })
    .refine(
      ({ startDate, endDate }) =>
        (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24) <=
        MAX_BACKFILL_RANGE_DAYS,
      { message: `Date range cannot exceed ${MAX_BACKFILL_RANGE_DAYS} days.` },
    ),
  output: z.object({ results: z.array(TriggerSupportV2BackfillResult) }),
});

export type TriggerSupportV2BackfillInput = z.infer<
  typeof triggerSupportV2Backfill.input
>;

export type TriggerSupportV2BackfillOutput = z.infer<
  typeof triggerSupportV2Backfill.output
>;
